import script from "./fw27_admin_user_edit.vue?vue&type=script&setup=true&lang=js"
export * from "./fw27_admin_user_edit.vue?vue&type=script&setup=true&lang=js"

import "./fw27_admin_user_edit.vue?vue&type=style&index=0&id=6243429d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6243429d"]])

export default __exports__